module.exports = __webpack_public_path__ + "static/media/mahaaa.09fb4618.png";